export const WATERMARK_CONTAINER_CSS = '.UP_waterMark';
